import FlipClock from 'flipclock/src/js/Components/FlipClock';

export default class EventCountdown {
    static init() {
        Array.from(document.querySelectorAll('.flip-clock')).forEach(element => {
            new EventCountdown(element);
        });
    }

    constructor(element) {
        if (!element) return;
        this.element = element;
        let endDate = new Date(this.element.dataset.date);
        if (!endDate) return;
        let endTime = endDate.getTime();
        endDate = this.isInThePast(endTime) ? new Date() : endDate;

        this.counter = new FlipClock(element, endDate, {
            face: 'DayCounter',
            language: 'de',
            autoStart: false,
            minimumDigits: 0,
            countdown: true
        });

        !this.isInThePast(endTime) && this.counter.start();

        this.counter.$timer.on('interval', () => {
            let currentTime = Math.floor(this.counter.$timer.lastLoop / 1000) * 1000;
            if (currentTime === endTime - 1000) {
                this.counter.timer.isRunning && this.counter.stop();
            }
        });
    }

    isInThePast(time){
        return time < new Date().getTime();
    }
}
